/**
 * Event batch publish path: derive whether the session ORGANIZE row is out of sync.
 * While publication-state is loading or errored, return false so the UI does not show a false "republish" state.
 * Legacy (non-batch) callers pass `useBatchPath: false` and only `legacyOutOfSync` is used.
 */
export function sessionBatchOrganizeChildOutOfSync(options: {
  useBatchPath: boolean;
  canUpdateEvent: boolean;
  isPublicationStateLoading: boolean;
  isError: boolean;
  isPublicationStateReady: boolean;
  recordIsUpToDate: boolean | undefined;
  legacyOutOfSync: boolean;
}): boolean {
  const {
    useBatchPath,
    canUpdateEvent,
    isPublicationStateLoading,
    isError,
    isPublicationStateReady,
    recordIsUpToDate,
    legacyOutOfSync,
  } = options;

  if (!useBatchPath || !canUpdateEvent) {
    return legacyOutOfSync;
  }
  if (isError || isPublicationStateLoading || !isPublicationStateReady) {
    return false;
  }
  return recordIsUpToDate !== true;
}
